export default __webpack_public_path__ + "static/media/dashboard-home.df2a3694.svg";